var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("GridHome", {
        attrs: {
          "row-data": _vm.actividades,
          gridOptions: _vm.gridOptions,
          funcionalidadId: _vm.funcionalidad
        }
      }),
      _c(
        "v-card-text",
        {
          staticStyle: {
            padding: "10px",
            "text-align": "right",
            "padding-left": "5px"
          }
        },
        [
          _c("span", { staticStyle: { "font-size": "13px" } }, [
            _vm._v(
              "Mostrando " + _vm._s(_vm.cantidadActiviadades) + " Actividades"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }